import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import { GlobalUtils } from "../../utils";

// Destructuring
const { truncateString } = GlobalUtils;

const Breadcrumb = ({ breadcrumbData, currentFolderID }) => {
  if (breadcrumbData && breadcrumbData.length > 0) {
    return (
      <div className="breadcrumb-container">
        <FontAwesomeIcon
          icon={["fas", "border-all"]}
          className="breadcrumb-bredcrumb-hdd"
        />
        {breadcrumbData &&
          breadcrumbData.map((bc, index) => (
            <div className="breadcrumb-bredcrumb-item" key={bc.id}>
              <Link to={encodeURI(encodeURI(bc.url))}>
                <span
                  className={`breadcrumb-bredcrumb-text ${
                    currentFolderID === bc.id ? "active-bredcrumb" : ""
                  }`}>
                  <span>{truncateString(bc.name, 16, true)}</span>
                  {/* {bc.name} */}
                </span>
              </Link>
              {index < breadcrumbData.length - 1 && (
                <FontAwesomeIcon
                  icon={["far", "angle-right"]}
                  className="breadcrumb-bredcrumb-icon"
                />
              )}
            </div>
          ))}
      </div>
    );
  }
  return null;
};

Breadcrumb.propTypes = {
  breadcrumbData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  currentFolderID: PropTypes.string.isRequired,
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/commonComponents/Breadcrumbs/Breadcrumb.js